import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { GlobalState, reducers } from './';

export default function configureStore(initialState?: GlobalState) {
    const middleware = [thunk];

    const rootReducer = combineReducers({
        ...reducers
    });

    const enhancers = [] as any[];
    const windowIfDefined = typeof window === 'undefined' ? null : window as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    return createStore(
        rootReducer,
        initialState as any,
        compose(applyMiddleware(...middleware), ...enhancers) as any
    );
}
